import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const invoiceGuard: CanActivateFn = (route, state) => {
    const platformId = inject(PLATFORM_ID);
    const router = inject(Router);

    if (isPlatformBrowser(platformId)) {
        const savedPayment = localStorage.getItem('payment_response');
        if (savedPayment) {
            try {
                const parsed = JSON.parse(savedPayment);
                if (parsed && parsed.cart) {
                    return true;
                }
            } catch (e) {
                console.error('Error parsing payment data in guard', e);
            }
        } else {
            return router.parseUrl('/');
        }
    }

    // Allow route to pass on the server-side (SSR) so the browser can check localStorage
    return true;
};
